import { Link } from "react-router-dom";
import { useNextT } from "../../i18n";
import { useAccess } from "../../access/api";
import { useDefaultLandingPage } from "../../bridges/session";
import { rich } from "../../contacts/components/dialogs";
import { ManagerHelp } from "../../access/components/ManagerHelp";
import link from "../../access/components/Notices.module.scss";
import s from "./NotAvailablePage.module.scss";

/** Board 137 (D1.3): typing /duchot without access. No menu item leads here; one way forward. */
export const NotAvailablePage = () => {
  const { t } = useNextT();
  const owner = useAccess().data?.workspace.owner?.name;
  const home = useDefaultLandingPage();
  return (
    <div className={`cy-next ${s.page}`}>
      <div className={s.state}>
        <h1 className={s.title}>{t("reports.not_available.title")}</h1>
        <p className={s.body}>{owner ? rich(t, "reports.not_available.body", {}, { owner: <bdi>{owner}</bdi> }) : t("reports.not_available.body_no_owner")}</p>
        <Link to={home} className={`${link.link} ${link.primary}`}>{t("reports.not_available.home")}</Link>
        <ManagerHelp />
      </div>
    </div>
  );
};
